import(/* webpackMode: "eager" */ "/app/app/[lng]/application/invoices/new-invoice/page.tsx");
